import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=276d87ba"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276d87ba')) {
      api.createRecord('276d87ba', component.options)
    } else {
      api.reload('276d87ba', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=276d87ba", function () {
      api.rerender('276d87ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/my_subscription/Detail.vue"
export default component.exports